import "../../../../../src/styles/index.scss";
import * as React from 'react';
export default {
  React
};